export default __webpack_public_path__ + "static/media/check-v2.25031974.svg";